import { FC } from "react";
import styled from "styled-components";
import { P2, ParagraphProps } from "./Paragraph";
import { color as themeColor } from "@styles";
import { createArray, roundToNearestHalf } from "@utils";
import { Anchor } from "./Anchor";
import { TrustpilotStar } from "components/atoms/Trustpilot";
import { mobile } from "components/templates/Breakpoints";
import { useLocale } from "next-intl";
import { convertNewlinesToBreaks } from "@hooks";

interface Props {
  inverted?: boolean;
  score?: number;
  copy?: string;
  isCenterAligned?: boolean;
}

export const TrustpilotMini: FC<React.PropsWithChildren<Props>> = ({
  score = 4.7,
  inverted = false,
  copy = "Our customers say",
  isCenterAligned = false,
}) => {
  const trustScore = roundToNearestHalf(score);
  const locale = useLocale();

  return (
    <Container isCenterAligned={isCenterAligned}>
      <Flex>
        {createArray(5).map((_, index) => (
          <TrustpilotStar key={`trustpilot-star-${index}`} index={index} trustScore={trustScore} />
        ))}
      </Flex>
      {locale === "jp" ? (
        <ModifiedP2 inverted={inverted} isCenterAligned={isCenterAligned}>
          {convertNewlinesToBreaks(copy)}
        </ModifiedP2>
      ) : (
        <ModifiedP2 inverted={inverted} isCenterAligned={isCenterAligned}>
          {copy}{" "}
          <ModifiedAnchor
            href="https://uk.trustpilot.com/review/www.yulife.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>Excellent on Trustpilot</strong>
          </ModifiedAnchor>
        </ModifiedP2>
      )}
    </Container>
  );
};

const Flex = styled.div`
  display: inline-flex;
  gap: 0.125rem;
  margin-right: 1rem;
`;

const Container = styled.div<{
  isCenterAligned: boolean;
}>`
  padding-top: ${(p) => (p.isCenterAligned ? "3rem" : "2rem")};
  ${(p) => p.isCenterAligned && "display: flex; align-items: center; margin-bottom: 2rem;"}
`;

const ModifiedP2 = styled(P2)<ParagraphProps & { inverted?: boolean; isCenterAligned: boolean }>`
  display: inline-block;
  line-height: 1.25rem;
  color: ${(p) => (p.inverted ? "#fff" : themeColor.B1100)};
  padding-top: ${(p) => (p.isCenterAligned ? "0" : "1rem")};

  ${mobile} {
    padding-bottom: ${(p) => (p.isCenterAligned ? "0" : "2rem")};
`;

const ModifiedAnchor = styled(Anchor)`
  display: inline-block;
`;
